import React, {useCallback} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import OnboardingCompleteModal from "features/modals/onboarding/complete";
import {getHomeDataStart} from "features/pages/home/reducer";
import {getHomeData, getHomeDataError, getHomeDataLoading} from "features/pages/home/selectors";
import Title from "features/components/title";
import {__} from "services/i18n";
import {withToastManager} from "react-toast-notifications";
import {HorizontalScrollSection} from "features/components/horizontal-scroll-section";
import VideoCard from "features/components/video-card";
import {DirectoryCard} from "features/components/directory-card";
import {LoadingLogoPortal} from "features/components/loading-logo";
import EventCard from "features/components/event-card";
import ThreadCard from "features/components/thread-card";
import PeopleCard from "features/components/people-card";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: getHomeData(state),
    loading: getHomeDataLoading(state),
    error: getHomeDataError(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getHomeDataStart
};
export const HomePage = (props) => {
    const {getHomeDataStart, data, loading, error} = props;

    React.useEffect(() => {
        getHomeDataStart();
    }, [getHomeDataStart])

    React.useEffect(() => {
        if(!error.inError) return;
        props.toastManager.add(__(error.error), { appearance: 'error', id: 'getHomeData.error' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    const ctaSection = useCallback(() => {
        const videos = data.cta;
        if(!videos.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.cta")}</Title>
            <HorizontalScrollSection>
                {
                    videos.map(item => <VideoCard key={item.id} video={item} type={"dark"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const workoutSection = useCallback(() => {
        const videos = data.workouts;
        if(!videos.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.workout")}</Title>
            <HorizontalScrollSection>
                {
                    videos.map(item => <VideoCard key={item.id} video={item} type={"dark"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);

    const videoSection = useCallback(() => {
        const videos = data.video;
        if(!videos.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.video")}</Title>
            <HorizontalScrollSection>
                {
                    videos.map(item => <VideoCard key={item.id} video={item} type={"dark"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const recentlySection = useCallback(() => {
        const videos = data.recent_video;
        if(!videos.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.recent")}</Title>
            <HorizontalScrollSection>
                {
                    videos.map(item => <VideoCard key={item.id} video={item} type={"dark"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const directorySection = useCallback(() => {
        const directories = data.directory_video;
        if(!directories.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.directories")}</Title>
            <HorizontalScrollSection>
                {
                    directories.map(item => <DirectoryCard key={item.id} directory={item} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const categorySection = useCallback(() => {
        const videos = data.category_video.list;
        if(!videos.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.category", [{key: "[category]", value: data.category_video.category}])}</Title>
            <HorizontalScrollSection>
                {
                    videos.map(item => <VideoCard key={item.id} video={item} type={"dark"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const eventsSection = useCallback(() => {
        const events = data.events;
        if(!events.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.events")}</Title>
            <HorizontalScrollSection>
                {
                    events.map(item => <EventCard event={item} key={item.id} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const threadsSection = useCallback(() => {
        const threads = data.threads;
        if(!threads.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.threads")}</Title>
            <HorizontalScrollSection>
                {
                    threads.map(item => <ThreadCard item={item} key={item.id} color={"dark"} type={"small"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const usersSection = useCallback(() => {
        const items = data.users;
        if(!items.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.users")}</Title>
            <HorizontalScrollSection>
                {
                    items.map(item => <PeopleCard item={item} key={item.id} type={"vertical"} color={"dark"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);
    const companiesSection = useCallback(() => {
        const items = data.companies;
        if(!items.length) return null;
        return <div className="home-section">
            <Title size={34}>{__("home.titles.companies")}</Title>
            <HorizontalScrollSection>
                {
                    items.map(item => <PeopleCard item={item} key={item.id} type={"vertical"} color={"dark"} />)
                }
            </HorizontalScrollSection>
        </div>
    }, [data]);

    return <LoggedInLayout
                className="home-page"
                breadcrumbs={[{title: "common.home-breadcrumb", link:"/"}, {title: "home.breadcrumb"}]}
                showTutorialButton={true}
            >

        {loading && <LoadingLogoPortal />}
        {videoSection()}
        {data.cta && ctaSection()}
        {data.workouts && workoutSection()}
        {threadsSection()}
        {usersSection()}
        {companiesSection()}
        {eventsSection()}
        {recentlySection()}
        {directorySection()}
        {categorySection()}
        <OnboardingCompleteModal />
    </LoggedInLayout>
};

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(HomePage));